import { createSelector } from "reselect"
import { get, chain } from "lodash"
import { createQueryStringSelector } from "selectors/queryString"
import { getUnmodeledDates } from "selectors/dates"
import { getNextModeledDate, isUnmodeledDate, isDateValid, clampDate } from "helpers/dates"

export const getModelsAvailability = state => get(state, "global.data.modelsAvailability.data.models")
export const getSelectedModelId = (_, props) => get(props, "modelId")
const getRawSelectedDate = createQueryStringSelector("date")

export const getModelCurrentDate = createSelector(
  [getModelsAvailability, getSelectedModelId],
  (modelsAvailability, selectedModelId) => chain(modelsAvailability).find({ id: selectedModelId }).get("availability.currentDate").value(),
)

export const getModelStartDate = createSelector(
  [getModelsAvailability, getSelectedModelId],
  (modelsAvailability, selectedModelId) => chain(modelsAvailability).find({ id: selectedModelId }).get("availability.securitiesStartDate").value(),
)

export const getSelectedDate = createSelector(
  [getModelStartDate, getModelCurrentDate, getRawSelectedDate, getUnmodeledDates],
  (startDate, currentDate, rawSelectedDate, unmodeledDates) => {
    if (!startDate || !currentDate) {
      return null
    }

    if (rawSelectedDate && isDateValid(rawSelectedDate)) {
      let selectedDate = clampDate(rawSelectedDate, startDate, currentDate)
      if (isUnmodeledDate(selectedDate, unmodeledDates)) {
        selectedDate = getNextModeledDate(selectedDate, currentDate, unmodeledDates)
      }
      return selectedDate
    }

    return currentDate
  },
)

export const getIsSelectedDateAdjusted = createSelector(
  [getRawSelectedDate, getSelectedDate],
  (rawSelectedDate, selectedDate) => rawSelectedDate && rawSelectedDate !== selectedDate,
)
